import { COOKIE_KEY } from "@/constants/cookieKey";
import useAppStore from "@/context/store";
import { safeParse } from "@/utils/safeParse";
import Cookies from "js-cookie";
enum TYPE {
  "ORIGINAL", // 不处理
  "REMOVE_GD", // 去除bucket前缀的gd-
  "ADD_GD", // 添加bucket前缀的gd-
}

class ImageUrlConfig {
  imageConfig: {
    domain: string;
    bucket?: string;
    bucketHandMethod: TYPE;
  };
  init: boolean;
  constructor() {
    // 默认需要做一套兜底配置
    this.imageConfig = {
      domain: "huaban.com",
      bucketHandMethod: TYPE.ADD_GD,
    };
    this.init = false;
  }

  get(originBucket) {
    // 服务端时imageUrlConfig为单例，需要直接返回
    if (typeof window === "undefined") {
      const cookieImgConfig = safeParse(
        useAppStore.getState()?.initImageConfig,
        () => undefined
      );
      /**
       * 取配置顺序
       * 1.cookie设置的
       * 2.杂货铺第一个
       * 3.代码兜底
       */
      const imageConfig =
        cookieImgConfig ||
        useAppStore.getState()?.config?.imageConfigList?.[0] ||
        this.imageConfig;

      imageConfig.bucket = this.getBucket(
        originBucket,
        imageConfig.bucketHandMethod
      );

      return imageConfig;
    } else {
      if (!this.init) {
        this.init = true;

        const cookieImgConfig = safeParse(
          Cookies.get(COOKIE_KEY.IMAGE_URL_CONFIG),
          () => undefined
        );
        /**
         * 取配置顺序
         * 1.cookie设置的
         * 2.杂货铺第一个
         * 3.代码兜底
         */
        this.imageConfig =
          cookieImgConfig ||
          useAppStore.getState()?.config?.imageConfigList?.[0] ||
          this.imageConfig;
      }
      // bucket每次都需要处理下
      this.imageConfig.bucket = this.getBucket(
        originBucket,
        this.imageConfig.bucketHandMethod
      );
      return this.imageConfig;
    }
    // 客户端
  }
  getBucket = (originBucket, bucketHandMethod) => {
    switch (bucketHandMethod) {
      case TYPE.ORIGINAL:
        return originBucket;
      case TYPE.REMOVE_GD:
        return originBucket.replace(/^gd-/, "");
      default:
        if (originBucket.indexOf("gd-") !== 0) {
          originBucket = "gd-" + originBucket;
        }
        return originBucket;
    }
  };
  set(imageConfig) {
    this.imageConfig = imageConfig;
    Cookies.set(COOKIE_KEY.IMAGE_URL_CONFIG, imageConfig);
  }
}
const imageUrlConfig = new ImageUrlConfig();

export { imageUrlConfig };
